// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1mja1","alertIcon":"ConfirmModal_alertIcon__2j_xA"};